// Angular:
import {
    Component,
    ContentChild,
    Inject,
    Input,
    OnDestroy,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';

// Dependencies:
import { isBool, isNotNull, Value } from '@trademe/ensure';
import { StepIndicatorIconDirective } from '../step-indicator-icon/step-indicator-icon.directive';
import {
    IStepIndicatorComponent,
    stepIndicatorComponentInjection
} from '../step-indicator/istep-indicator.component';

@Component({
    selector: 'tm-step-indicator-item',
    templateUrl: 'step-indicator-item.component.html'
})
export class StepIndicatorItemComponent implements OnDestroy {
    @Input() @Value(isNotNull) public id: any;
    @Input() @Value(isBool) public disabled: boolean;
    @Input() @Value(isNotNull) public title: string;

    @ContentChild(StepIndicatorIconDirective, { read: TemplateRef })
    public icon: TemplateRef<any>;

    @ViewChild('content', { read: TemplateRef, static: true })
    public content: TemplateRef<any>;

    public active: boolean;

    private _destroyed$ = new Subject();

    constructor(
        @Inject(stepIndicatorComponentInjection)
        private stepIndicatorComponent: IStepIndicatorComponent
    ) {}

    public ngOnDestroy(): void {
        this._destroyed$.next(true);
    }

    public select(): void {
        this.stepIndicatorComponent.select(this);
    }
}
